module.exports = __webpack_public_path__ + "static/datadog_logo3-bc2bb4698ac977159e52f28af532df0d.jpeg";